// extracted by mini-css-extract-plugin
export var optionGrid = "_94-7";
export var optionList = "_94-6";
export var questionsBlock = "_94-9";
export var spacer = "_94-5";
export var stepCenteredContent = "_94-3";
export var stepInner = "_94-0";
export var stepInnerFullWidth = "_94-1";
export var stepInnerLockScroll = "_94-2";
export var stepTransitionFrame = "_94-4";
export var welcomeBlock = "_94-8";